import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { DevToolSection, devFieldStack, devHint, devLabel } from '/imports/ui/DevToolSection';
import { Input } from '/imports/ui/Input';
import { runGoatbotsJob } from '/imports/api/devtools';

export const DevToolGoatbots = () => {
  const [sets, setSets] = useState('');
  const [loading, setLoading] = useState(false);
  const [lastJobId, setLastJobId] = useState<string>('');

  const run = async () => {
    setLoading(true);
    try {
      const res = await runGoatbotsJob.call({ sets });
      setLastJobId(res.jobId);
      const what = sets.trim() ? res.sets.join(', ') : `all ${res.sets.length} scheduled set(s)`;
      toast.success(`Goatbots job enqueued (${res.jobId}): ${what}`);
    }
    catch (e: any) {
      toast.error(e.message || `${e}`);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <DevToolSection
      title="Run Goatbots Price Fetch"
      description="Manually enqueue the goatbotsJob. Browses goatbots.com, screenshots each set page, sends to Claude for parsing, and updates <code>cards.gbBuyPrice</code> / <code>cards.gbSellPrice</code>. Watch server logs for progress."
      buttonText="Enqueue Job"
      onRun={run}
      loading={loading}
    >
      <div className={devFieldStack}>
        <div>
          <label className={devLabel}>Set codes (optional)</label>
          <Input
            value={sets}
            onChange={(v) => setSets(v ?? '')}
            placeholder="MH3, OTJ — empty scrapes every scheduled set"
          />
        </div>
      </div>
      {lastJobId && (
        <div className={devHint}>
          Last enqueued jobId: <code className="font-mono">{lastJobId}</code>
        </div>
      )}
    </DevToolSection>
  );
};
